// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Зв’язки записів» (Record Links, ключ `rel`, група `basic`). */
export const recordLinksManifest: IModuleManifest = {
  key: 'rel',
  group: 'basic',
  slug: 'record-links',
  prefix: 'REL',
  name: { en: 'Record Links', uk: 'Зв’язки записів' },
  entities: [
    { key: 'rel', slug: 'rel', name: { en: 'Record Links', uk: 'Зв’язки записів' }, main: true },
    { key: 'link_type', slug: 'link-type', name: { en: 'Link Types', uk: 'Типи зв’язків' }, main: false },
    { key: 'link_direction', slug: 'link-direction', name: { en: 'Link Directions', uk: 'Напрямки' }, main: false },
  ],
  loadState: () => import('./state/recordLinksSlice').then((m) => m.recordLinksSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
